import { render } from "./SubCategoryList.vue?vue&type=template&id=e4c1eafe"
import script from "./SubCategoryList.vue?vue&type=script&lang=js"
export * from "./SubCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__